<template>
  <div>
    <div class="col col--3 col--inline mq-mob-lrg--12"></div>

    <div class="col col--inline mq-mob-lrg--12 col--6">
      <div class="auth">
        <h2 class="auth__ttl">Reset password</h2>

        <p>
          Enter your email address below. We'll then send you an email with
          instructions on how to reset your password.
        </p>

        <form class="form" @submit.prevent="resetPassword">
          <div class="form__field">
            <input
              type="email"
              v-model="form.email"
              class="form__input form__input--secondary"
              placeholder="eg joebloggs@hotmail.com..."
            />
            <span class="error" v-if="form.errors.has('email')">{{
              form.errors.get("email")
            }}</span>
          </div>

          <div class="auth__btn">
            <a href="/account/auth" class="auth__btn__link">Login</a>
            <button
              :disabled="form.busy"
              type="submit"
              class="auth__btn__item btn btn--quaternary"
            >
              {{ form.busy ? "Please wait..." : "Reset password" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Form } from "vform";
export default {
  data() {
    return {
      form: new Form({
        email: "",
      }),
    };
  },
  methods: {
    resetPassword() {
      this.form
        .post("/account/forgot")
        .then((response) => {
          this.form.email = "";
          this.$alert(
            "We've sent you an email. Please follow the instructions on that to reset your password. Don't forget to check your junk mail.",
            "Password reset",
            {
              confirmButtonText: "OK",
            }
          );
        })
        .catch((e) => {
          if (e.response.status == 404) {
            this.form.email = "";
            this.$alert(
              "We've sent you an email. Please follow the instructions on that to reset your password. Don't forget to check your junk mail.",
              "Password reset",
              {
                confirmButtonText: "OK",
              }
            );
          }
        });
    },
  },
};
</script>

<style>
.error {
  display: block;
  color: red;
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/AuthForgot.vue